const GROUPMSG = {
  // widget
  WIDGET_PART_TITLE: 'Public Communication via Widget',
  WIDGET_PART_DESC:
    'With this feature, you can send a specific message to all website visitors through the Raychat widget. Precise, fast, and cost-effective communication! You can send up to #num# messages in a single day.',

  //whatsapp
  WHATSAPP_PART_TITLE: 'Group message via WhatsApp',
  WHATSAPP_PART_DESC:
    'Despite this feature, if you have already connected your website to your WhatsApp through the WhatsApp connection operation, you can send a general message to all the game conversations you have with your WhatsApp contacts. You can send up to five messages in one day.',

  // mutual
  EVENT_TYPE_GROUP: 'Group Message',
  EVENT_TYPE_SELECT_TITLE: 'Choose how to send',
  MSG_INPUT_PLACEHOLDER: 'Message',
  FORM_SUBMIT_BTN: 'Send',

  WEBSITE_SELECT_ERROR: 'Please select website',
  EMPTY_MSG_ERROR: 'Please enter your message',
  EVENT_TYPE_ERROR: 'Please select event type',
};

export default GROUPMSG;
